import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import SEO from '../../components/SEO';
import Galaxy from '../../assets/svg/Galaxy';
import Lock from '../../assets/svg/Lock';
import Unlock from '../../assets/svg/Unlock';
import NavExpander from '../../containers/NavExpander';
import WaveText from '../../components/WaveText';
import styles from './promptGenerator.css';
import Config from '../../config';

const PromptGenerator = () => {
  const { whats, whos, wheres, wildCards } = Config.promptGenerator;
  const [paramValues, setParamValues] = useState({
    what: '',
    who: '',
    where: '',
    wildCard: '',
  });

  const [lockedParams, setLockedParams] = useState({
    what: false,
    who: false,
    where: false,
    wildCard: false,
  });

  const toggleParamLock = param => {
    setLockedParams({ ...lockedParams, [param]: !lockedParams[param] });
  };

  const regenerate = () => {
    const what = lockedParams['what']
      ? paramValues.what
      : whats[Math.floor(Math.random() * whats.length)];
    const who = lockedParams['who']
      ? paramValues.who
      : whos[Math.floor(Math.random() * whos.length)];
    const where = lockedParams['where']
      ? paramValues.where
      : wheres[Math.floor(Math.random() * wheres.length)];
    const wildCard = lockedParams['wildCard']
      ? paramValues.wildCard
      : wildCards[Math.floor(Math.random() * wildCards.length)];

    setParamValues({ what, who, where, wildCard });
  };

  useEffect(regenerate, []);

  const renderPropParam = paramName => {
    return (
      <span className={`${styles.promptParam} ${lockedParams[paramName] ? styles.locked : ''}`}>
        <span className={styles.promptText}>{paramValues[paramName]}</span>
        <button className={styles.lockButton} onClick={() => toggleParamLock(paramName)}>
          {lockedParams[paramName] ? <Lock /> : <Unlock />}
        </button>
      </span>
    );
  };

  return (
    <div>
      <SEO title="Design Prompt Generator" path="/design-prompt-generator" />
      <NavExpander tabIndex="0">
        <section className={styles.wrapper}>
          <div className={styles.content}>
            <div className={styles.waveTextTop}>
              <WaveText text="What Will Fate Bring To Your Desktop?" rate={3} />
              <WaveText text="Unlock Your Creativity And Save Your Soul" rate={3} />
            </div>
            <p className={styles.prompt}>
              Design a {renderPropParam('what')} for {renderPropParam('who')} in{' '}
              {renderPropParam('where')}. And the hard part: {renderPropParam('wildCard')}{' '}
            </p>
            <button className={styles.refreshButton} onClick={regenerate}>
              <Galaxy />
              <span className={styles.refreshText}>Remix</span>
            </button>
            <div className={styles.waveTextBottom}>
              <WaveText text="What Is Your Design Destiny?" rate={3} />
              <WaveText text="Find Your Font Based Fortune." rate={3} />
            </div>
          </div>
        </section>
      </NavExpander>
    </div>
  );
};

export default withRouter(PromptGenerator);
